import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 9989309E-22E1-46F6-B710-6717D1C5EA11
 * name arrow-collapse-down
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-collapse-down.svg
 * tags
 * - Arrow 
 */
export const ArrowCollapseDownIcon = createSvgIcon(<><path d="M19.92,12.08L12,20L4.08,12.08L5.5,10.67L11,16.17V2H13V16.17L18.5,10.66L19.92,12.08M12,20H2V22H22V20H12Z" /></>, 'ArrowCollapseDownIcon');
export default ArrowCollapseDownIcon